export default {
    user:{},
    msisdn: ''
};
